export * from './data-filter.pipe';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/pipes/dataFilter/index.ts